export const AVG_RENT_PRICES = [
  {
    mittl_preis_qm_miete: 8.33633999,
    min_preis_qm_miete: 5.809999943,
    max_preis_qm_miete: 12,
    name: 'Neukölln',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 10.13768499,
    min_preis_qm_miete: 6.849999905,
    max_preis_qm_miete: 15,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 7.92184812,
    min_preis_qm_miete: 5.690000057,
    max_preis_qm_miete: 11,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 7.648860194,
    min_preis_qm_miete: 5.510000229,
    max_preis_qm_miete: 10.90999985,
    name: 'Reinickendorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 10.29688432,
    min_preis_qm_miete: 6.1199998860000004,
    max_preis_qm_miete: 17.02000046,
    name: 'Mitte',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 7.072762596,
    min_preis_qm_miete: 5.300000191,
    max_preis_qm_miete: 9.5,
    name: 'Spandau',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 6.382678877,
    min_preis_qm_miete: 4.909999847,
    max_preis_qm_miete: 9.090000153,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 8.792820529,
    min_preis_qm_miete: 6.190000057,
    max_preis_qm_miete: 12.42000008,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 7.961203209,
    min_preis_qm_miete: 5.6199998860000004,
    max_preis_qm_miete: 10.82999992,
    name: 'Lichtenberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 8.706283356,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 12.67000008,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 10.42325385,
    min_preis_qm_miete: 6.960000038,
    max_preis_qm_miete: 14.15999985,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 9.347187596,
    min_preis_qm_miete: 6.239999771,
    max_preis_qm_miete: 13.25,
    name: 'Pankow',
    zeit: '2015-Q1',
  },
  {
    mittl_preis_qm_miete: 8.444465584,
    min_preis_qm_miete: 5.900000095,
    max_preis_qm_miete: 12.26000023,
    name: 'Neukölln',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 10.16427303,
    min_preis_qm_miete: 6.949999809,
    max_preis_qm_miete: 15,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 7.90124723,
    min_preis_qm_miete: 5.78000021,
    max_preis_qm_miete: 10.89999962,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 7.747331746,
    min_preis_qm_miete: 5.829999924,
    max_preis_qm_miete: 10.80000019,
    name: 'Reinickendorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 10.57843415,
    min_preis_qm_miete: 6.260000229,
    max_preis_qm_miete: 17.13999939,
    name: 'Mitte',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 7.201297589,
    min_preis_qm_miete: 5.539999962,
    max_preis_qm_miete: 9.760000229,
    name: 'Spandau',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 6.432094469,
    min_preis_qm_miete: 5,
    max_preis_qm_miete: 9.289999962,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 9.0334193,
    min_preis_qm_miete: 6.5,
    max_preis_qm_miete: 12.88000011,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 8.020557861,
    min_preis_qm_miete: 5.650000095,
    max_preis_qm_miete: 11.30000019,
    name: 'Lichtenberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 8.821068377,
    min_preis_qm_miete: 6.099999905,
    max_preis_qm_miete: 12.77000046,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 10.4795233,
    min_preis_qm_miete: 7.010000229,
    max_preis_qm_miete: 14.02999973,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 9.412461439,
    min_preis_qm_miete: 6.320000172,
    max_preis_qm_miete: 13.5,
    name: 'Pankow',
    zeit: '2015-Q2',
  },
  {
    mittl_preis_qm_miete: 8.595693543,
    min_preis_qm_miete: 5.900000095,
    max_preis_qm_miete: 12.96000004,
    name: 'Neukölln',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 10.21377207,
    min_preis_qm_miete: 6.769999981,
    max_preis_qm_miete: 15.71000004,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 7.997263881,
    min_preis_qm_miete: 5.769999981,
    max_preis_qm_miete: 11,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 7.750532759,
    min_preis_qm_miete: 5.789999962,
    max_preis_qm_miete: 10.93999958,
    name: 'Reinickendorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 10.55929958,
    min_preis_qm_miete: 6.190000057,
    max_preis_qm_miete: 17.34000015,
    name: 'Mitte',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 7.115749791,
    min_preis_qm_miete: 5.3800001139999996,
    max_preis_qm_miete: 9.479999542,
    name: 'Spandau',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 6.476459056,
    min_preis_qm_miete: 4.989999771,
    max_preis_qm_miete: 9.569999695,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 9.090379991,
    min_preis_qm_miete: 6.550000191,
    max_preis_qm_miete: 12.97000027,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 8.124297788,
    min_preis_qm_miete: 5.789999962,
    max_preis_qm_miete: 11.5,
    name: 'Lichtenberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 8.691067636,
    min_preis_qm_miete: 6.079999924,
    max_preis_qm_miete: 12.94999981,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 10.57188436,
    min_preis_qm_miete: 6.78000021,
    max_preis_qm_miete: 14.52000046,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 9.399837246,
    min_preis_qm_miete: 6.059999943,
    max_preis_qm_miete: 13.85000038,
    name: 'Pankow',
    zeit: '2015-Q3',
  },
  {
    mittl_preis_qm_miete: 9.479135621,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 13.64000034,
    name: 'Neukölln',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 10.59911632,
    min_preis_qm_miete: 6.8800001139999996,
    max_preis_qm_miete: 16.5,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 8.320397779,
    min_preis_qm_miete: 6.059999943,
    max_preis_qm_miete: 11.5,
    name: 'Treptow-Köpenick',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 7.999586216,
    min_preis_qm_miete: 5.760000229,
    max_preis_qm_miete: 10.93999958,
    name: 'Reinickendorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 11.28286137,
    min_preis_qm_miete: 6.230000019,
    max_preis_qm_miete: 18.11000061,
    name: 'Mitte',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 7.299909231,
    min_preis_qm_miete: 5.260000229,
    max_preis_qm_miete: 10,
    name: 'Spandau',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 6.756921893,
    min_preis_qm_miete: 5.190000057,
    max_preis_qm_miete: 10.38000011,
    name: 'Marzahn-Hellersdorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 9.307455476,
    min_preis_qm_miete: 6.309999943,
    max_preis_qm_miete: 13.5,
    name: 'Steglitz-Zehlendorf',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 8.069819965,
    min_preis_qm_miete: 5.659999847,
    max_preis_qm_miete: 12.19999981,
    name: 'Lichtenberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 9.027942325,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 13.59000015,
    name: 'Tempelhof-Schöneberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 11.42776471,
    min_preis_qm_miete: 6.789999962,
    max_preis_qm_miete: 15.81000042,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 9.812491496,
    min_preis_qm_miete: 6.039999962,
    max_preis_qm_miete: 14.01000023,
    name: 'Pankow',
    zeit: '2015-Q4',
  },
  {
    mittl_preis_qm_miete: 9.659045611,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 13.47999954,
    name: 'Neukölln',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 10.5970676,
    min_preis_qm_miete: 6.840000153,
    max_preis_qm_miete: 16.06999969,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 8.36380448,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 11.69999981,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 7.951982842,
    min_preis_qm_miete: 5.909999847,
    max_preis_qm_miete: 10.89000034,
    name: 'Reinickendorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 10.86011528,
    min_preis_qm_miete: 6.25,
    max_preis_qm_miete: 18.88999939,
    name: 'Mitte',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 7.256349213,
    min_preis_qm_miete: 5.260000229,
    max_preis_qm_miete: 9.75,
    name: 'Spandau',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 6.851849592,
    min_preis_qm_miete: 5.199999809,
    max_preis_qm_miete: 10.02999973,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 9.382445451,
    min_preis_qm_miete: 6.519999981,
    max_preis_qm_miete: 13.65999985,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 8.422655246,
    min_preis_qm_miete: 5.71999979,
    max_preis_qm_miete: 12,
    name: 'Lichtenberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 9.041930988,
    min_preis_qm_miete: 6.1300001139999996,
    max_preis_qm_miete: 13.76000023,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 10.97502662,
    min_preis_qm_miete: 6.510000229,
    max_preis_qm_miete: 15.46000004,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 9.915626165,
    min_preis_qm_miete: 6.409999847,
    max_preis_qm_miete: 14.47000027,
    name: 'Pankow',
    zeit: '2016-Q1',
  },
  {
    mittl_preis_qm_miete: 9.816868827,
    min_preis_qm_miete: 6.1300001139999996,
    max_preis_qm_miete: 13.92000008,
    name: 'Neukölln',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 10.88959811,
    min_preis_qm_miete: 7.03000021,
    max_preis_qm_miete: 16.70999908,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 8.526404414,
    min_preis_qm_miete: 6.059999943,
    max_preis_qm_miete: 12,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 8.081684497,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 11,
    name: 'Reinickendorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 11.08523273,
    min_preis_qm_miete: 6.400000095,
    max_preis_qm_miete: 18.88999939,
    name: 'Mitte',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 7.433437244,
    min_preis_qm_miete: 5.449999809,
    max_preis_qm_miete: 10,
    name: 'Spandau',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 6.939211065,
    min_preis_qm_miete: 5.159999847,
    max_preis_qm_miete: 10.02999973,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 9.500773883,
    min_preis_qm_miete: 6.699999809,
    max_preis_qm_miete: 13.89999962,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 8.545230938,
    min_preis_qm_miete: 5.820000172,
    max_preis_qm_miete: 12.14999962,
    name: 'Lichtenberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 9.252356567,
    min_preis_qm_miete: 6.199999809,
    max_preis_qm_miete: 14.03999996,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 11.39909449,
    min_preis_qm_miete: 7.139999866,
    max_preis_qm_miete: 16,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 10.13111457,
    min_preis_qm_miete: 6.639999866,
    max_preis_qm_miete: 15,
    name: 'Pankow',
    zeit: '2016-Q2',
  },
  {
    mittl_preis_qm_miete: 10.09400425,
    min_preis_qm_miete: 6.199999809,
    max_preis_qm_miete: 13.98999977,
    name: 'Neukölln',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 11.19669428,
    min_preis_qm_miete: 7.1300001139999996,
    max_preis_qm_miete: 16.87999916,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 8.812104303,
    min_preis_qm_miete: 6.150000095,
    max_preis_qm_miete: 12.5,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 8.34727092,
    min_preis_qm_miete: 6.059999943,
    max_preis_qm_miete: 11.42000008,
    name: 'Reinickendorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 11.55239808,
    min_preis_qm_miete: 6.639999866,
    max_preis_qm_miete: 19.70000076,
    name: 'Mitte',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 7.647723439,
    min_preis_qm_miete: 5.579999924,
    max_preis_qm_miete: 10.51000023,
    name: 'Spandau',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 6.981087162,
    min_preis_qm_miete: 5.159999847,
    max_preis_qm_miete: 10.36999989,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 9.781231264,
    min_preis_qm_miete: 6.940000057,
    max_preis_qm_miete: 14,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 8.813812094,
    min_preis_qm_miete: 5.909999847,
    max_preis_qm_miete: 12.35999966,
    name: 'Lichtenberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 9.642491081,
    min_preis_qm_miete: 6.53000021,
    max_preis_qm_miete: 14.32999992,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 11.72221939,
    min_preis_qm_miete: 7.199999809,
    max_preis_qm_miete: 16.85000038,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 10.16631081,
    min_preis_qm_miete: 6.599999905,
    max_preis_qm_miete: 15,
    name: 'Pankow',
    zeit: '2016-Q3',
  },
  {
    mittl_preis_qm_miete: 10.3094844,
    min_preis_qm_miete: 6.25,
    max_preis_qm_miete: 14.23999977,
    name: 'Neukölln',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 11.17568587,
    min_preis_qm_miete: 7,
    max_preis_qm_miete: 16.67000008,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 8.916875431,
    min_preis_qm_miete: 6.349999905,
    max_preis_qm_miete: 12.5,
    name: 'Treptow-Köpenick',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 8.441191336,
    min_preis_qm_miete: 6.059999943,
    max_preis_qm_miete: 11.53999996,
    name: 'Reinickendorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 12.01147723,
    min_preis_qm_miete: 6.6300001139999996,
    max_preis_qm_miete: 20,
    name: 'Mitte',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 7.685257292,
    min_preis_qm_miete: 5.420000076,
    max_preis_qm_miete: 10.56000042,
    name: 'Spandau',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 7.11232062,
    min_preis_qm_miete: 5.159999847,
    max_preis_qm_miete: 10.59000015,
    name: 'Marzahn-Hellersdorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 9.891488753,
    min_preis_qm_miete: 6.920000076,
    max_preis_qm_miete: 14.5,
    name: 'Steglitz-Zehlendorf',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 8.939221835,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 12.10999966,
    name: 'Lichtenberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 9.838858263,
    min_preis_qm_miete: 6.570000172,
    max_preis_qm_miete: 14.75,
    name: 'Tempelhof-Schöneberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 11.86813748,
    min_preis_qm_miete: 7.429999828,
    max_preis_qm_miete: 16.63999939,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 10.47619094,
    min_preis_qm_miete: 6.599999905,
    max_preis_qm_miete: 15.19999981,
    name: 'Pankow',
    zeit: '2016-Q4',
  },
  {
    mittl_preis_qm_miete: 10.2925134,
    min_preis_qm_miete: 6.320000172,
    max_preis_qm_miete: 14.43999958,
    name: 'Neukölln',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 11.56063544,
    min_preis_qm_miete: 7.429999828,
    max_preis_qm_miete: 17.20000076,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 9.096938651,
    min_preis_qm_miete: 6.460000038,
    max_preis_qm_miete: 12.65999985,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 8.816891594,
    min_preis_qm_miete: 6.139999866,
    max_preis_qm_miete: 12.39999962,
    name: 'Reinickendorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 12.31903824,
    min_preis_qm_miete: 6.900000095,
    max_preis_qm_miete: 19.65999985,
    name: 'Mitte',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 7.689218617,
    min_preis_qm_miete: 5.519999981,
    max_preis_qm_miete: 10.60000038,
    name: 'Spandau',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 7.235540954,
    min_preis_qm_miete: 5.159999847,
    max_preis_qm_miete: 10.59000015,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 9.919473688,
    min_preis_qm_miete: 6.96999979,
    max_preis_qm_miete: 14.18000031,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 9.138921679,
    min_preis_qm_miete: 6.389999866,
    max_preis_qm_miete: 12.5,
    name: 'Lichtenberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 9.874432823,
    min_preis_qm_miete: 6.559999943,
    max_preis_qm_miete: 14.61999989,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 11.85688164,
    min_preis_qm_miete: 7.300000191,
    max_preis_qm_miete: 16.35000038,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 10.68673236,
    min_preis_qm_miete: 6.800000191,
    max_preis_qm_miete: 15.84000015,
    name: 'Pankow',
    zeit: '2017-Q1',
  },
  {
    mittl_preis_qm_miete: 10.35566566,
    min_preis_qm_miete: 6.3800001139999996,
    max_preis_qm_miete: 16,
    name: 'Neukölln',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 12.05460382,
    min_preis_qm_miete: 7.789999962,
    max_preis_qm_miete: 18,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 9.32786581,
    min_preis_qm_miete: 6.480000019,
    max_preis_qm_miete: 13,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 8.780936077,
    min_preis_qm_miete: 6.170000076,
    max_preis_qm_miete: 12.77000046,
    name: 'Reinickendorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 12.66784876,
    min_preis_qm_miete: 7.110000134,
    max_preis_qm_miete: 19.97999954,
    name: 'Mitte',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 7.931919199,
    min_preis_qm_miete: 5.659999847,
    max_preis_qm_miete: 10.85999966,
    name: 'Spandau',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 7.404491533,
    min_preis_qm_miete: 5.199999809,
    max_preis_qm_miete: 11.18000031,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 10.14195847,
    min_preis_qm_miete: 7.1199998860000004,
    max_preis_qm_miete: 14.5,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 9.446945494,
    min_preis_qm_miete: 6.71999979,
    max_preis_qm_miete: 13.31000042,
    name: 'Lichtenberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 10.04788581,
    min_preis_qm_miete: 6.650000095,
    max_preis_qm_miete: 14.48999977,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 12.25832588,
    min_preis_qm_miete: 7.420000076,
    max_preis_qm_miete: 17.79000092,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 10.802321,
    min_preis_qm_miete: 6.769999981,
    max_preis_qm_miete: 16.13999939,
    name: 'Pankow',
    zeit: '2017-Q2',
  },
  {
    mittl_preis_qm_miete: 10.3038206,
    min_preis_qm_miete: 6.460000038,
    max_preis_qm_miete: 16,
    name: 'Neukölln',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 12.07977961,
    min_preis_qm_miete: 7.800000191,
    max_preis_qm_miete: 18.04999924,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 9.593823901,
    min_preis_qm_miete: 6.6199998860000004,
    max_preis_qm_miete: 13.05000019,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 8.859221266,
    min_preis_qm_miete: 6.300000191,
    max_preis_qm_miete: 12.96000004,
    name: 'Reinickendorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 12.86910554,
    min_preis_qm_miete: 7.329999924,
    max_preis_qm_miete: 20,
    name: 'Mitte',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 8.180097194,
    min_preis_qm_miete: 5.980000019,
    max_preis_qm_miete: 11.14999962,
    name: 'Spandau',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 7.956248346,
    min_preis_qm_miete: 5.559999943,
    max_preis_qm_miete: 11.46000004,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 10.26590062,
    min_preis_qm_miete: 7,
    max_preis_qm_miete: 14.56999969,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 9.697635659,
    min_preis_qm_miete: 6.699999809,
    max_preis_qm_miete: 13.52000046,
    name: 'Lichtenberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 10.03997124,
    min_preis_qm_miete: 6.6199998860000004,
    max_preis_qm_miete: 15,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 12.73160337,
    min_preis_qm_miete: 7.579999924,
    max_preis_qm_miete: 18.51000023,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 11.05856332,
    min_preis_qm_miete: 6.860000134,
    max_preis_qm_miete: 16.67000008,
    name: 'Pankow',
    zeit: '2017-Q3',
  },
  {
    mittl_preis_qm_miete: 10.35430868,
    min_preis_qm_miete: 6.510000229,
    max_preis_qm_miete: 15.02000046,
    name: 'Neukölln',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 12.09378454,
    min_preis_qm_miete: 7.5,
    max_preis_qm_miete: 18.70999908,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 9.695218287,
    min_preis_qm_miete: 6.670000076,
    max_preis_qm_miete: 13.5,
    name: 'Treptow-Köpenick',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 8.929007952,
    min_preis_qm_miete: 6.3699998860000004,
    max_preis_qm_miete: 12.63000011,
    name: 'Reinickendorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 13.1485451,
    min_preis_qm_miete: 7.269999981,
    max_preis_qm_miete: 20.10000038,
    name: 'Mitte',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 8.279702648,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 11.35999966,
    name: 'Spandau',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 7.991807909,
    min_preis_qm_miete: 5.559999943,
    max_preis_qm_miete: 11.65999985,
    name: 'Marzahn-Hellersdorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 10.34554554,
    min_preis_qm_miete: 7.199999809,
    max_preis_qm_miete: 14.39999962,
    name: 'Steglitz-Zehlendorf',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 9.781843187,
    min_preis_qm_miete: 6.909999847,
    max_preis_qm_miete: 13.51000023,
    name: 'Lichtenberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 10.2167007,
    min_preis_qm_miete: 6.690000057,
    max_preis_qm_miete: 15.77000046,
    name: 'Tempelhof-Schöneberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 12.85191413,
    min_preis_qm_miete: 7.949999809,
    max_preis_qm_miete: 18.51000023,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 11.25525242,
    min_preis_qm_miete: 6.849999905,
    max_preis_qm_miete: 17.23999977,
    name: 'Pankow',
    zeit: '2017-Q4',
  },
  {
    mittl_preis_qm_miete: 10.63336179,
    min_preis_qm_miete: 6.610000134,
    max_preis_qm_miete: 15.60999966,
    name: 'Neukölln',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 12.49405358,
    min_preis_qm_miete: 8.289999962,
    max_preis_qm_miete: 18.59000015,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 9.904369974,
    min_preis_qm_miete: 6.96999979,
    max_preis_qm_miete: 13.77999973,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 9.344401501,
    min_preis_qm_miete: 6.53000021,
    max_preis_qm_miete: 13.39000034,
    name: 'Reinickendorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 13.42044769,
    min_preis_qm_miete: 7.900000095,
    max_preis_qm_miete: 20.47999954,
    name: 'Mitte',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 8.451546384,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 11.57999992,
    name: 'Spandau',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 8.12477877,
    min_preis_qm_miete: 5.71999979,
    max_preis_qm_miete: 11.77000046,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 10.57165304,
    min_preis_qm_miete: 7.590000153,
    max_preis_qm_miete: 14.97999954,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 10.08567819,
    min_preis_qm_miete: 7.010000229,
    max_preis_qm_miete: 14,
    name: 'Lichtenberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 10.4677473,
    min_preis_qm_miete: 6.8800001139999996,
    max_preis_qm_miete: 15.5,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 13.15052189,
    min_preis_qm_miete: 8.359999657,
    max_preis_qm_miete: 18.81999969,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 11.41792642,
    min_preis_qm_miete: 7.159999847,
    max_preis_qm_miete: 17.5,
    name: 'Pankow',
    zeit: '2018-Q1',
  },
  {
    mittl_preis_qm_miete: 10.82559959,
    min_preis_qm_miete: 6.599999905,
    max_preis_qm_miete: 16.67000008,
    name: 'Neukölln',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 12.69697815,
    min_preis_qm_miete: 8.399999619,
    max_preis_qm_miete: 18.45999908,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 9.964161082,
    min_preis_qm_miete: 6.96999979,
    max_preis_qm_miete: 13.98999977,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 9.402853443,
    min_preis_qm_miete: 6.5,
    max_preis_qm_miete: 13.39000034,
    name: 'Reinickendorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 13.69974736,
    min_preis_qm_miete: 7.820000172,
    max_preis_qm_miete: 21.28000069,
    name: 'Mitte',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 8.602507597,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 11.53999996,
    name: 'Spandau',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 8.114528013,
    min_preis_qm_miete: 5.760000229,
    max_preis_qm_miete: 11.80000019,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 10.78362556,
    min_preis_qm_miete: 7.409999847,
    max_preis_qm_miete: 15.19999981,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 10.08580557,
    min_preis_qm_miete: 7.010000229,
    max_preis_qm_miete: 14.53999996,
    name: 'Lichtenberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 10.68958067,
    min_preis_qm_miete: 7.110000134,
    max_preis_qm_miete: 15.71000004,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 13.38108581,
    min_preis_qm_miete: 8.010000229,
    max_preis_qm_miete: 20,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 11.61588003,
    min_preis_qm_miete: 7.210000038,
    max_preis_qm_miete: 18,
    name: 'Pankow',
    zeit: '2018-Q2',
  },
  {
    mittl_preis_qm_miete: 11.05176922,
    min_preis_qm_miete: 6.889999866,
    max_preis_qm_miete: 17,
    name: 'Neukölln',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 13.02644373,
    min_preis_qm_miete: 8.510000229,
    max_preis_qm_miete: 19.48999977,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 9.977239039,
    min_preis_qm_miete: 6.96999979,
    max_preis_qm_miete: 14.15999985,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 9.609557412,
    min_preis_qm_miete: 6.5,
    max_preis_qm_miete: 14.02000046,
    name: 'Reinickendorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 14.01432665,
    min_preis_qm_miete: 7.599999905,
    max_preis_qm_miete: 23.63999939,
    name: 'Mitte',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 8.757585861,
    min_preis_qm_miete: 6.360000134,
    max_preis_qm_miete: 11.81000042,
    name: 'Spandau',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 8.302080223,
    min_preis_qm_miete: 5.800000191,
    max_preis_qm_miete: 12.02999973,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 11.05924099,
    min_preis_qm_miete: 7.579999924,
    max_preis_qm_miete: 16,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 9.939039197,
    min_preis_qm_miete: 6.429999828,
    max_preis_qm_miete: 15,
    name: 'Lichtenberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 11.34898832,
    min_preis_qm_miete: 7.170000076,
    max_preis_qm_miete: 17.43000031,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 13.79260453,
    min_preis_qm_miete: 8.159999847,
    max_preis_qm_miete: 20.06999969,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 11.99206264,
    min_preis_qm_miete: 7.440000057,
    max_preis_qm_miete: 18.5,
    name: 'Pankow',
    zeit: '2018-Q3',
  },
  {
    mittl_preis_qm_miete: 10.92658307,
    min_preis_qm_miete: 6.889999866,
    max_preis_qm_miete: 17.27000046,
    name: 'Neukölln',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 13.22670298,
    min_preis_qm_miete: 8.529999733,
    max_preis_qm_miete: 19.76000023,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 10.21069406,
    min_preis_qm_miete: 6.820000172,
    max_preis_qm_miete: 15,
    name: 'Treptow-Köpenick',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 9.725780487,
    min_preis_qm_miete: 6.670000076,
    max_preis_qm_miete: 14.28999996,
    name: 'Reinickendorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 14.1601046,
    min_preis_qm_miete: 8,
    max_preis_qm_miete: 22.84000015,
    name: 'Mitte',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 8.874610774,
    min_preis_qm_miete: 6.260000229,
    max_preis_qm_miete: 12.10000038,
    name: 'Spandau',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 8.305456801,
    min_preis_qm_miete: 5.860000134,
    max_preis_qm_miete: 12.18000031,
    name: 'Marzahn-Hellersdorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 11.01237163,
    min_preis_qm_miete: 7.670000076,
    max_preis_qm_miete: 15.64999962,
    name: 'Steglitz-Zehlendorf',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 10.05887682,
    min_preis_qm_miete: 6.199999809,
    max_preis_qm_miete: 15.02000046,
    name: 'Lichtenberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 11.48968566,
    min_preis_qm_miete: 7.460000038,
    max_preis_qm_miete: 17.5,
    name: 'Tempelhof-Schöneberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 14.0554945,
    min_preis_qm_miete: 9.170000076,
    max_preis_qm_miete: 20.54999924,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 11.99837687,
    min_preis_qm_miete: 7.039999962,
    max_preis_qm_miete: 18.17000008,
    name: 'Pankow',
    zeit: '2018-Q4',
  },
  {
    mittl_preis_qm_miete: 10.9787667,
    min_preis_qm_miete: 6.800000191,
    max_preis_qm_miete: 19,
    name: 'Neukölln',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 13.64554045,
    min_preis_qm_miete: 8.819999695,
    max_preis_qm_miete: 21.70000076,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 10.31887483,
    min_preis_qm_miete: 6.900000095,
    max_preis_qm_miete: 15,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 9.915443197,
    min_preis_qm_miete: 6.659999847,
    max_preis_qm_miete: 15,
    name: 'Reinickendorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 14.77127906,
    min_preis_qm_miete: 8.43999958,
    max_preis_qm_miete: 24.46999931,
    name: 'Mitte',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 8.925004466,
    min_preis_qm_miete: 6.309999943,
    max_preis_qm_miete: 12,
    name: 'Spandau',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 8.456071899,
    min_preis_qm_miete: 5.849999905,
    max_preis_qm_miete: 12.55000019,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 11.29264819,
    min_preis_qm_miete: 7.53000021,
    max_preis_qm_miete: 16,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 9.929091942,
    min_preis_qm_miete: 6.010000229,
    max_preis_qm_miete: 14.97000027,
    name: 'Lichtenberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 11.34268659,
    min_preis_qm_miete: 7.139999866,
    max_preis_qm_miete: 17.80999947,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 14.44981096,
    min_preis_qm_miete: 8.579999924,
    max_preis_qm_miete: 20.98999977,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 11.85838159,
    min_preis_qm_miete: 6.900000095,
    max_preis_qm_miete: 19.59000015,
    name: 'Pankow',
    zeit: '2019-Q1',
  },
  {
    mittl_preis_qm_miete: 11.46606321,
    min_preis_qm_miete: 6.730000019,
    max_preis_qm_miete: 20,
    name: 'Neukölln',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 14.04503341,
    min_preis_qm_miete: 9.06000042,
    max_preis_qm_miete: 22.64999962,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 10.54611626,
    min_preis_qm_miete: 7,
    max_preis_qm_miete: 15.85000038,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 9.943847395,
    min_preis_qm_miete: 6.739999771,
    max_preis_qm_miete: 14.96000004,
    name: 'Reinickendorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 15.34789786,
    min_preis_qm_miete: 8.5,
    max_preis_qm_miete: 25.26000023,
    name: 'Mitte',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 9.152297874,
    min_preis_qm_miete: 6.3699998860000004,
    max_preis_qm_miete: 12.5,
    name: 'Spandau',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 8.593489646,
    min_preis_qm_miete: 5.96999979,
    max_preis_qm_miete: 12.77000046,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 11.63301888,
    min_preis_qm_miete: 7.75,
    max_preis_qm_miete: 17.89999962,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 10.12855953,
    min_preis_qm_miete: 5.920000076,
    max_preis_qm_miete: 15.25,
    name: 'Lichtenberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 11.79570082,
    min_preis_qm_miete: 7.059999943,
    max_preis_qm_miete: 18.62999916,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 14.75595159,
    min_preis_qm_miete: 8.869999886,
    max_preis_qm_miete: 23.22999954,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 12.49162457,
    min_preis_qm_miete: 7.139999866,
    max_preis_qm_miete: 20.95000076,
    name: 'Pankow',
    zeit: '2019-Q2',
  },
  {
    mittl_preis_qm_miete: 11.50835508,
    min_preis_qm_miete: 6.46999979,
    max_preis_qm_miete: 20,
    name: 'Neukölln',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 13.64447107,
    min_preis_qm_miete: 7.659999847,
    max_preis_qm_miete: 22.07999992,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 10.47538756,
    min_preis_qm_miete: 6.679999828,
    max_preis_qm_miete: 16.12999916,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 9.992953154,
    min_preis_qm_miete: 6.570000172,
    max_preis_qm_miete: 15.22999954,
    name: 'Reinickendorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 14.57610347,
    min_preis_qm_miete: 7.519999981,
    max_preis_qm_miete: 24.63999939,
    name: 'Mitte',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 9.078113196,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 13.39000034,
    name: 'Spandau',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 8.284348242,
    min_preis_qm_miete: 5.900000095,
    max_preis_qm_miete: 12.68000031,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 11.30573467,
    min_preis_qm_miete: 7.420000076,
    max_preis_qm_miete: 16.95999908,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 9.638073472,
    min_preis_qm_miete: 5.889999866,
    max_preis_qm_miete: 14.97999954,
    name: 'Lichtenberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 11.58807925,
    min_preis_qm_miete: 7.03000021,
    max_preis_qm_miete: 18.92000008,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 14.5525075,
    min_preis_qm_miete: 8.130000114,
    max_preis_qm_miete: 23.01000023,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 12.09958892,
    min_preis_qm_miete: 6.8800001139999996,
    max_preis_qm_miete: 20.20999908,
    name: 'Pankow',
    zeit: '2019-Q3',
  },
  {
    mittl_preis_qm_miete: 11.76701639,
    min_preis_qm_miete: 6.6199998860000004,
    max_preis_qm_miete: 19.56999969,
    name: 'Neukölln',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 13.73365223,
    min_preis_qm_miete: 8.010000229,
    max_preis_qm_miete: 22.54000092,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 10.51301431,
    min_preis_qm_miete: 6.599999905,
    max_preis_qm_miete: 16.01000023,
    name: 'Treptow-Köpenick',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 10.23835501,
    min_preis_qm_miete: 6.650000095,
    max_preis_qm_miete: 15.31000042,
    name: 'Reinickendorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 14.55771442,
    min_preis_qm_miete: 7.449999809,
    max_preis_qm_miete: 24.29000092,
    name: 'Mitte',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 9.249890097,
    min_preis_qm_miete: 6.409999847,
    max_preis_qm_miete: 13.5,
    name: 'Spandau',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 8.536754886,
    min_preis_qm_miete: 5.989999771,
    max_preis_qm_miete: 13.02999973,
    name: 'Marzahn-Hellersdorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 11.42539574,
    min_preis_qm_miete: 7.420000076,
    max_preis_qm_miete: 17.13999939,
    name: 'Steglitz-Zehlendorf',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 9.83456898,
    min_preis_qm_miete: 5.8699998860000004,
    max_preis_qm_miete: 15.5,
    name: 'Lichtenberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 11.34263425,
    min_preis_qm_miete: 7.019999981,
    max_preis_qm_miete: 18.67000008,
    name: 'Tempelhof-Schöneberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 14.35268456,
    min_preis_qm_miete: 7.699999809,
    max_preis_qm_miete: 23.23999977,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 12.21022059,
    min_preis_qm_miete: 6.909999847,
    max_preis_qm_miete: 20,
    name: 'Pankow',
    zeit: '2019-Q4',
  },
  {
    mittl_preis_qm_miete: 11.23851765,
    min_preis_qm_miete: 6.1199998860000004,
    max_preis_qm_miete: 20,
    name: 'Neukölln',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 13.55369436,
    min_preis_qm_miete: 7.289999962,
    max_preis_qm_miete: 22.21999931,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 10.92983103,
    min_preis_qm_miete: 6.449999809,
    max_preis_qm_miete: 16.61000061,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 10.019843,
    min_preis_qm_miete: 6.400000095,
    max_preis_qm_miete: 15,
    name: 'Reinickendorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 15.03155367,
    min_preis_qm_miete: 7.039999962,
    max_preis_qm_miete: 26.25,
    name: 'Mitte',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 9.298983962,
    min_preis_qm_miete: 6.269999981,
    max_preis_qm_miete: 14.51000023,
    name: 'Spandau',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 8.721409486,
    min_preis_qm_miete: 5.8800001139999996,
    max_preis_qm_miete: 13.64000034,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 11.25287933,
    min_preis_qm_miete: 6.980000019,
    max_preis_qm_miete: 17.98999977,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 9.659100475,
    min_preis_qm_miete: 5.579999924,
    max_preis_qm_miete: 16,
    name: 'Lichtenberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 10.93240276,
    min_preis_qm_miete: 6.349999905,
    max_preis_qm_miete: 18.29999924,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 14.50694094,
    min_preis_qm_miete: 7.429999828,
    max_preis_qm_miete: 23.76000023,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 12.12894633,
    min_preis_qm_miete: 6.420000076,
    max_preis_qm_miete: 20,
    name: 'Pankow',
    zeit: '2020-Q1',
  },
  {
    mittl_preis_qm_miete: 11.35654061,
    min_preis_qm_miete: 5.8800001139999996,
    max_preis_qm_miete: 20.96999931,
    name: 'Neukölln',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 13.98275743,
    min_preis_qm_miete: 7.1300001139999996,
    max_preis_qm_miete: 23.57999992,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 10.83333633,
    min_preis_qm_miete: 6.039999962,
    max_preis_qm_miete: 17,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 9.845839406,
    min_preis_qm_miete: 6.170000076,
    max_preis_qm_miete: 15.07999992,
    name: 'Reinickendorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 15.11693447,
    min_preis_qm_miete: 6.409999847,
    max_preis_qm_miete: 27.89999962,
    name: 'Mitte',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 9.009301312,
    min_preis_qm_miete: 5.829999924,
    max_preis_qm_miete: 14.63000011,
    name: 'Spandau',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 7.913423132,
    min_preis_qm_miete: 5.230000019,
    max_preis_qm_miete: 12.67000008,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 11.58001312,
    min_preis_qm_miete: 6.71999979,
    max_preis_qm_miete: 19.70999908,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 9.165437683,
    min_preis_qm_miete: 5.400000095,
    max_preis_qm_miete: 15.5,
    name: 'Lichtenberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 11.19984333,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 20.5,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 14.32763031,
    min_preis_qm_miete: 6.590000153,
    max_preis_qm_miete: 24.17000008,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 11.94332112,
    min_preis_qm_miete: 6.070000172,
    max_preis_qm_miete: 20.34000015,
    name: 'Pankow',
    zeit: '2020-Q2',
  },
  {
    mittl_preis_qm_miete: 10.80798866,
    min_preis_qm_miete: 5.650000095,
    max_preis_qm_miete: 21.13999939,
    name: 'Neukölln',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 14.27184074,
    min_preis_qm_miete: 7.1300001139999996,
    max_preis_qm_miete: 24.64999962,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 10.82836119,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 17.70000076,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 9.948809516,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 16.67000008,
    name: 'Reinickendorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 15.6121939,
    min_preis_qm_miete: 6.449999809,
    max_preis_qm_miete: 28.29999924,
    name: 'Mitte',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 9.003870969,
    min_preis_qm_miete: 5.739999771,
    max_preis_qm_miete: 15.56000042,
    name: 'Spandau',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 8.072506344,
    min_preis_qm_miete: 5.269999981,
    max_preis_qm_miete: 13.78999996,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 11.64439352,
    min_preis_qm_miete: 6.71999979,
    max_preis_qm_miete: 19.73999977,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 8.720603903,
    min_preis_qm_miete: 5.440000057,
    max_preis_qm_miete: 16.63999939,
    name: 'Lichtenberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 11.29395406,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 21.62000084,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 14.49876904,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 24.39999962,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 11.81622964,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 21.61000061,
    name: 'Pankow',
    zeit: '2020-Q3',
  },
  {
    mittl_preis_qm_miete: 11.45219047,
    min_preis_qm_miete: 5.96999979,
    max_preis_qm_miete: 22.47999954,
    name: 'Neukölln',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 14.5115707,
    min_preis_qm_miete: 7.1300001139999996,
    max_preis_qm_miete: 24.78000069,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 11.0294655,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 18,
    name: 'Treptow-Köpenick',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 10.11531194,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 18,
    name: 'Reinickendorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 15.51204571,
    min_preis_qm_miete: 6.449999809,
    max_preis_qm_miete: 27.69000053,
    name: 'Mitte',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 9.471053324,
    min_preis_qm_miete: 5.889999866,
    max_preis_qm_miete: 15.5,
    name: 'Spandau',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 8.386625166,
    min_preis_qm_miete: 5.480000019,
    max_preis_qm_miete: 13.59000015,
    name: 'Marzahn-Hellersdorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 11.62233745,
    min_preis_qm_miete: 6.559999943,
    max_preis_qm_miete: 19.61000061,
    name: 'Steglitz-Zehlendorf',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 9.288360465,
    min_preis_qm_miete: 5.420000076,
    max_preis_qm_miete: 17.71999931,
    name: 'Lichtenberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 11.38719178,
    min_preis_qm_miete: 5.710000038,
    max_preis_qm_miete: 22.60000038,
    name: 'Tempelhof-Schöneberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 14.80414947,
    min_preis_qm_miete: 6.699999809,
    max_preis_qm_miete: 25.70999908,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 12.51716697,
    min_preis_qm_miete: 6.079999924,
    max_preis_qm_miete: 22,
    name: 'Pankow',
    zeit: '2020-Q4',
  },
  {
    mittl_preis_qm_miete: 11.14870777,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 23.29999924,
    name: 'Neukölln',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 14.88204724,
    min_preis_qm_miete: 7.050000191,
    max_preis_qm_miete: 25,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 11.51608201,
    min_preis_qm_miete: 6.039999962,
    max_preis_qm_miete: 19,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 10.3784473,
    min_preis_qm_miete: 5.699999809,
    max_preis_qm_miete: 18.75,
    name: 'Reinickendorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 15.84754562,
    min_preis_qm_miete: 6.440000057,
    max_preis_qm_miete: 27.69000053,
    name: 'Mitte',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 9.752516212,
    min_preis_qm_miete: 5.760000229,
    max_preis_qm_miete: 18,
    name: 'Spandau',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 8.504946238,
    min_preis_qm_miete: 5.269999981,
    max_preis_qm_miete: 13.97999954,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 11.66567479,
    min_preis_qm_miete: 6.079999924,
    max_preis_qm_miete: 20,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 9.146621897,
    min_preis_qm_miete: 5.409999847,
    max_preis_qm_miete: 19.63999939,
    name: 'Lichtenberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 11.21540831,
    min_preis_qm_miete: 5.949999809,
    max_preis_qm_miete: 23.14999962,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 14.54807471,
    min_preis_qm_miete: 6.28000021,
    max_preis_qm_miete: 25.47999954,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 12.67255337,
    min_preis_qm_miete: 6.039999962,
    max_preis_qm_miete: 23.34000015,
    name: 'Pankow',
    zeit: '2021-Q1',
  },
  {
    mittl_preis_qm_miete: 11.29662211,
    min_preis_qm_miete: 5.829999924,
    max_preis_qm_miete: 23.22999954,
    name: 'Neukölln',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 14.93842012,
    min_preis_qm_miete: 7.269999981,
    max_preis_qm_miete: 25,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 11.767376,
    min_preis_qm_miete: 6.400000095,
    max_preis_qm_miete: 19,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 10.87624606,
    min_preis_qm_miete: 6.25,
    max_preis_qm_miete: 20,
    name: 'Reinickendorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 15.5368854,
    min_preis_qm_miete: 6.539999962,
    max_preis_qm_miete: 27.67000008,
    name: 'Mitte',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 9.224807999,
    min_preis_qm_miete: 5.639999866,
    max_preis_qm_miete: 16.67000008,
    name: 'Spandau',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 9.117980443,
    min_preis_qm_miete: 5.829999924,
    max_preis_qm_miete: 14.02000046,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 12.25179523,
    min_preis_qm_miete: 6.739999771,
    max_preis_qm_miete: 21.12000084,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 10.46514388,
    min_preis_qm_miete: 5.570000172,
    max_preis_qm_miete: 20.93000031,
    name: 'Lichtenberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 11.63370629,
    min_preis_qm_miete: 6.050000191,
    max_preis_qm_miete: 22.89999962,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 13.85608697,
    min_preis_qm_miete: 6.329999924,
    max_preis_qm_miete: 24.34000015,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 13.27933386,
    min_preis_qm_miete: 6.409999847,
    max_preis_qm_miete: 23.44000053,
    name: 'Pankow',
    zeit: '2021-Q2',
  },
  {
    mittl_preis_qm_miete: 10.97052095,
    min_preis_qm_miete: 6.019999981,
    max_preis_qm_miete: 21.63999939,
    name: 'Neukölln',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 14.90158141,
    min_preis_qm_miete: 7.059999943,
    max_preis_qm_miete: 26.25,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 11.89838599,
    min_preis_qm_miete: 6.5,
    max_preis_qm_miete: 19.20000076,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 10.7781735,
    min_preis_qm_miete: 5.889999866,
    max_preis_qm_miete: 20,
    name: 'Reinickendorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 15.18298821,
    min_preis_qm_miete: 6.429999828,
    max_preis_qm_miete: 28.56999969,
    name: 'Mitte',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 9.192413782,
    min_preis_qm_miete: 5.639999866,
    max_preis_qm_miete: 16.36000061,
    name: 'Spandau',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 9.21010835,
    min_preis_qm_miete: 5.559999943,
    max_preis_qm_miete: 15,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 12.66301162,
    min_preis_qm_miete: 6.989999771,
    max_preis_qm_miete: 20.5,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 10.31527812,
    min_preis_qm_miete: 5.579999924,
    max_preis_qm_miete: 19.95000076,
    name: 'Lichtenberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 11.71928571,
    min_preis_qm_miete: 6.260000229,
    max_preis_qm_miete: 22.21999931,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 13.97200219,
    min_preis_qm_miete: 6.25,
    max_preis_qm_miete: 24.42000008,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 13.01097713,
    min_preis_qm_miete: 6.510000229,
    max_preis_qm_miete: 23.07999992,
    name: 'Pankow',
    zeit: '2021-Q3',
  },
  {
    mittl_preis_qm_miete: 11.66278514,
    min_preis_qm_miete: 6,
    max_preis_qm_miete: 23.38999939,
    name: 'Neukölln',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 16.11176221,
    min_preis_qm_miete: 7.429999828,
    max_preis_qm_miete: 28,
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 12.19455843,
    min_preis_qm_miete: 6.3800001139999996,
    max_preis_qm_miete: 20,
    name: 'Treptow-Köpenick',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 10.82214498,
    min_preis_qm_miete: 5.610000134,
    max_preis_qm_miete: 19.70000076,
    name: 'Reinickendorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 15.72407249,
    min_preis_qm_miete: 6.519999981,
    max_preis_qm_miete: 29.06999969,
    name: 'Mitte',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 9.571734269,
    min_preis_qm_miete: 5.489999771,
    max_preis_qm_miete: 18.18000031,
    name: 'Spandau',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 9.125736028,
    min_preis_qm_miete: 5.420000076,
    max_preis_qm_miete: 15.09000015,
    name: 'Marzahn-Hellersdorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 12.57741286,
    min_preis_qm_miete: 6.96999979,
    max_preis_qm_miete: 22.46999931,
    name: 'Steglitz-Zehlendorf',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 10.89272612,
    min_preis_qm_miete: 5.800000191,
    max_preis_qm_miete: 22.5,
    name: 'Lichtenberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 12.14717763,
    min_preis_qm_miete: 6.25,
    max_preis_qm_miete: 23.32999992,
    name: 'Tempelhof-Schöneberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 15.27176932,
    min_preis_qm_miete: 6.420000076,
    max_preis_qm_miete: 26.55999947,
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2021-Q4',
  },
  {
    mittl_preis_qm_miete: 13.42111543,
    min_preis_qm_miete: 6.5,
    max_preis_qm_miete: 23.44000053,
    name: 'Pankow',
    zeit: '2021-Q4',
  },
]
